import { StyleSheet } from "react-native";
import { Colors } from "react-native-paper";
import { pixelDimensions } from "../../../config/utils";

const styles = StyleSheet.create({
    content: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    viewBase: {
        flex: 1,
        backgroundColor: Colors.grey300
    },
    viewCoupom: {
        marginTop: pixelDimensions(5),
        alignSelf: "center",
        borderRadius: pixelDimensions(2),
        backgroundColor: Colors.white,
        flexDirection: "row",
        width: pixelDimensions(90)
    }
})

export default styles;